import {storage} from '@treatwell/ui';

type LocationPoint = {
  lat: number;
  lon: number;
};

type VenueBasketData = {
  treatmentCategoryIds: number[];
  locationPoint: LocationPoint;
};

export function getVenueTreatmentsAndLocation(
  venueId: number | null,
): VenueBasketData | null {
  if (!venueId) {
    return null;
  }

  const key = `venue-basket-treatmentCategoryIds-location-${venueId}`;
  const item = storage.local.getItem(key);

  if (!item) {
    return null;
  } else {
    const {treatmentCategoryIds, locationPoint} = item;

    if (
      Array.isArray(treatmentCategoryIds) &&
      typeof locationPoint?.lat === 'number' &&
      typeof locationPoint?.lon === 'number'
    ) {
      return {treatmentCategoryIds, locationPoint};
    }
    return null;
  }
}
